import { Outlet } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { LayoutProvider, MasterInit } from 'ufinet-web-components'

const Layout = () => {
	const NewLayoutProvider = LayoutProvider as any

	return (
		<NewLayoutProvider>
			<Outlet />
			<MasterInit />
			<ToastContainer />
		</NewLayoutProvider>
	)
}

export default Layout
